// Auto-capitalize each word as user types (for location/property/vendor names)
const LOWERCASE_WORDS = new Set(['a', 'an', 'the', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'by', 'de', 'du', 'la', 'le', 'des', 'von', 'van', 'di']);

export const toTitleCase = (str) => {
  if (!str) return str;
  return str.replace(/\S+/g, (word, index) => {
    if (index > 0 && LOWERCASE_WORDS.has(word.toLowerCase())) return word.toLowerCase();
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
};
